import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "SISENS - Restauration Collective d'Excellence Lyon | Cuisine Responsable",
  description = "SISENS réinvente la restauration collective à Lyon avec agilité, innovation et écoute. Fier de nos racines lyonnaises, nous allions tradition et modernité pour créer des expériences culinaires responsables, locales et gourmandes. Restauration d'entreprise, hospitalité et restauration scolaire.",
  keywords = "SISENS, SISENS Lyon, restauration collective, restauration collective Lyon, cuisine responsable, restauration entreprise Lyon, cantine entreprise, restauration scolaire Lyon, SISENS restauration",
  url = "https://sisens.eu",
  image = "https://customer-assets.emergentagent.com/job_sisens-cuisine/artifacts/3lootc7r_25.04.10%20SISENS%20LOGO.png",
  type = "website"
}) => {
  const fullTitle = title.includes('SISENS') ? title : `${title} | SISENS`;
  
  // Schema.org JSON-LD for organization
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "FoodEstablishment",
    "name": "SISENS",
    "alternateName": ["SISENS Lyon", "SISENS Restauration"],
    "description": "SISENS - Restauration collective d'excellence. Fier de nos racines lyonnaises, nous réinventons la restauration collective avec agilité, innovation et écoute. Cuisine responsable, locale et gourmande.",
    "url": "https://sisens.eu",
    "logo": image,
    "image": image,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Lyon",
      "addressRegion": "Auvergne-Rhône-Alpes",
      "addressCountry": "FR"
    },
    "servesCuisine": ["Cuisine collective responsable", "Cuisine locale", "Restauration d'entreprise"],
    "priceRange": "$$",
    "sameAs": [
      "https://www.linkedin.com/company/sisens"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "SISENS - Restauration Collective Lyon",
    "url": "https://sisens.eu",
    "description": description,
    "publisher": {
      "@type": "Organization",
      "name": "SISENS",
      "logo": {
        "@type": "ImageObject",
        "url": image
      }
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://sisens.eu/?s={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="SISENS" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="SISENS" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="French" />
      <meta name="revisit-after" content="7 days" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* Schema.org JSON-LD */}
      {type === 'website' && (
        <>
          <script type="application/ld+json">
            {JSON.stringify(organizationSchema)}
          </script>
          <script type="application/ld+json">
            {JSON.stringify(websiteSchema)}
          </script>
        </>
      )}
    </Helmet>
  );
};

export default SEO;
